module.exports = __webpack_public_path__ + "img/philin.27216f0d.png";